"use client";

import { FileEditIcon } from "lucide-react";

import type { TextEditorCodeExecutionToolResultContentBlock } from "../../types";
import { cn, truncate } from "../../utils";
import { CollapsibleSection } from "../CollapsibleSection";

interface TextEditorResultBlockProps {
  block: TextEditorCodeExecutionToolResultContentBlock;
  isStreaming?: boolean;
}

export const TextEditorResultBlock = ({
  block,
  isStreaming,
}: TextEditorResultBlockProps) => {
  const inner = block.content;
  const isError = inner.type?.endsWith("_error");

  let output: string;
  if (isError) {
    output = `${inner.error_code}: ${inner.error_message}`;
  } else if (inner.type?.includes("view")) {
    output = inner.content || "";
  } else if (inner.type?.includes("str_replace")) {
    output = inner.lines?.join("\n") || "";
  } else if (inner.type?.includes("create")) {
    output = inner.is_file_update ? "File updated" : "File created";
  } else {
    output = JSON.stringify(inner, null, 2);
  }

  return (
    <CollapsibleSection
      icon={<FileEditIcon className="h-3 w-3" />}
      label="Text Editor Result"
      preview={truncate(output)}
      copyContent={output}
      isStreaming={isStreaming}
    >
      <pre
        className={cn(
          "overflow-x-auto whitespace-pre-wrap break-words rounded-md bg-zinc-100 p-2 text-xs",
          isError ? "text-red-600" : "text-zinc-800",
        )}
      >
        {output}
      </pre>
    </CollapsibleSection>
  );
};
